import React from 'react'
import { IntlProvider } from 'react-intl'
import { create } from 'zustand'
import enUSMessages from './lang-compiled/en-US.json'
import resolveAcceptLanguage from 'resolve-accept-language'

// import pkg from '../package.json'
// const { supportedLocales: SUPPORTED_LOCALES } = pkg
const SUPPORTED_LOCALES = ['en-US', 'fr-FR', 'es-ES'] // TODO : get from package.json once we release nl-NL
const DEFAULT_LOCALE = 'en-US'

type I18nState = {
  locale: string
  messages: IntlProvider['props']['messages']
  setLocale(locale: string): Promise<void>
}

async function getMessagesFromLocale(locale: string) {
  return import(`./lang-compiled/${locale}.json`)
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(`Failed to load locale ${locale}`, error)
    })
    .then((messages) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return messages.default
    })
}

const useStore = create<I18nState>((set, get) => ({
  locale: DEFAULT_LOCALE,
  messages: enUSMessages,
  setLocale: async (locale: string) => {
    const resolved = resolveAcceptLanguage(
      locale,
      SUPPORTED_LOCALES,
      DEFAULT_LOCALE
    )
    if (resolved === get().locale) {
      return
    }
    const messages = await getMessagesFromLocale(resolved)
    set({ locale: resolved, messages })
  },
}))

// Autoload locale from browser
const navigatorLangs = navigator.languages.join(',')
useStore.getState().setLocale(navigatorLangs)

export function Provider({ children }: { children: React.ReactElement }) {
  const { locale, messages } = useStore()
  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}
